'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxForm = require('redux-form');

var _reactIntl = require('react-intl');

var _forms = require('utils/forms');

var _components2 = require('components');

var _forms2 = require('metadata/forms');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var firstNightHotelStub = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formTransferInformation.firstNightHotelStub',
    defaultMessage: '{stubText}',
    values: {
        stubText: _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'h4',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTransferInformation.firstNightHotelStubTitle',
                    defaultMessage: 'First Night Hotel' })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTransferInformation.firstNightHotelStubText',
                    defaultMessage: 'If you\'re not arriving on the first day of your tour,\n                                         we\'d like to know you\'re settled in and have a place\n                                         to stay when you arrive.' })
            )
        )
    } });

var earlyTransferBookedAckno = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formTransferInformation.earlyTransferBookedAckno',
    defaultMessage: '{stubText}',
    values: {
        stubText: _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'h4',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTransferInformation.earlyTransferBookedAcknoTitle',
                    defaultMessage: 'Early Transfer Booked' })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTransferInformation.earlyTransferBookedAcknoText',
                    defaultMessage: 'We can see that you\'re arriving nice and early for\n                                         your adventure! Please note that most hotels will\n                                         not allow check in until mid-afternoon. Drop your\n                                         bags off at the hotel, and go for an exploratory\n                                         walk or catch a nice breakfast in the meantime.' })
            )
        )
    } });

var TransferInformation = function TransferInformation(_ref) {
    var intl = _ref.intl,
        initialValues = _ref.initialValues,
        requirementsByCode = _ref.requirementsByCode,
        bookingId = _ref.bookingId,
        isFetchingRequirementData = _ref.isFetchingRequirementData,
        handleSubmit = _ref.handleSubmit,
        error = _ref.error,
        invalid = _ref.invalid,
        pristine = _ref.pristine,
        submitSucceeded = _ref.submitSucceeded,
        submitFailed = _ref.submitFailed,
        submitting = _ref.submitting;


    var firstNightHotelReq = requirementsByCode.FIRST_NIGHT_HOTEL;
    var earlyTransferBookedReq = requirementsByCode.EARLY_TRANSFER_BOOKED;

    var contactPrompt = _react2.default.createElement(_components2.DynamicCommunication, { type: 'contactPrompt' });

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_components2.FormErrorMessage, { errorCode: error, invalid: invalid, submitFailed: submitFailed, submitting: submitting }),
        _react2.default.createElement(
            'form',
            null,
            firstNightHotelReq && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_components2.FormStubText, { stubText: firstNightHotelStub }),
                _react2.default.createElement(_components2.FieldSet, {
                    className: 'single-col',
                    requirement: firstNightHotelReq,
                    fields: [{
                        label: firstNightHotelReq.status === 'INCOMPLETE' ? _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'formLabels.stubCompletionPrompt', values: { contactPrompt: contactPrompt } }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'formLabels.stubComplete' })
                    }] })
            ),
            earlyTransferBookedReq && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_components2.FormStubText, { stubText: earlyTransferBookedAckno }),
                _react2.default.createElement(_components2.FieldSet, {
                    className: 'single-col',
                    requirement: earlyTransferBookedReq,
                    fields: [(0, _extends3.default)({}, (0, _forms.generateOverride)({
                        intl: intl,
                        id: 'earlyTransferBookedAckno',
                        requirement: earlyTransferBookedReq,
                        overrideLabels: _forms2.formOverrides.acknowledgements,
                        bookingId: bookingId,
                        initialValues: initialValues
                    }))] })
            ),
            _react2.default.createElement(_components2.FormSubmit, {
                handleSubmit: handleSubmit,
                invalid: invalid,
                pristine: pristine,
                submitting: submitting,
                submitSucceeded: submitSucceeded,
                isFetchingRequirementData: isFetchingRequirementData })
        )
    );
};
TransferInformation.propTypes = {
    intl: _propTypes2.default.object.isRequired,
    initialValues: _propTypes2.default.object.isRequired,
    requirementsByCode: _propTypes2.default.object.isRequired,
    bookingId: _propTypes2.default.string.isRequired,
    isFetchingRequirementData: _propTypes2.default.bool.isRequired,
    handleSubmit: _propTypes2.default.func.isRequired,
    error: _propTypes2.default.string,
    invalid: _propTypes2.default.bool,
    pristine: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    submitSucceeded: _propTypes2.default.bool,
    submitFailed: _propTypes2.default.bool
};

exports.default = (0, _reactIntl.injectIntl)((0, _reduxForm.reduxForm)({
    form: 'TransferInformation',
    enableReinitialize: true
})(TransferInformation));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/forms/TransferInformation.js
// module id = 1327
// module chunks = 0